import GeneralHeroSection from "../educate/generalHeroSection";
import ContactFormComponent from "./contactFormComponent";
import SecondaryForm from "./secondaryFormComponent";


export default function ContactUsBodyComponent(props) {

    return (
        <div>

            <GeneralHeroSection title="Get in Touch"
                                blurb={<div>
                                    <p>
                                        Have questions about the program? Unsure which cohort fits you best? Need help with your application or financial aid? We’re here to help.</p>
                                </div>}

            />

            <div>
                <ContactFormComponent />
            </div>

        </div>
    )
}